<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.qualitative_reports', 2),
                        href: null,
                    },
                    {
                        name: student.group_name,
                        href: meta.links.group_index,
                    },
                    {
                        name: student.full_name,
                        href: null,
                    },
                ]"
            >
            </SmartBreadcrumbs>
        </template>

        <EmptyState picture v-if="records.data.length === 0">
            <template v-slot:picture />
        </EmptyState>
        <div class="flex flex-col mt-5" v-else>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(record, index) in records.data"
                                :key="record.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ record.date }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ student.latest_date || '-' }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex space-x-1 justify-end"
                                >
                                    <InertiaSquareLinkButton
                                        action="show"
                                        :href="record.links.show"
                                        :title="$t('messages.show')"
                                        v-if="record.links.show"
                                    />
                                    <InertiaSquareLinkButton
                                        action="edit"
                                        :href="record.links.edit"
                                        :title="$t('messages.edit')"
                                        v-if="record.links.edit"
                                    />
                                    <InertiaSquareDeleteButton :href="record.links.delete" v-if="record.links.delete" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';

export default {
    components: {
        InertiaSquareDeleteButton,
        EmptyState,
        PanelPage,
        InertiaSquareLinkButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'records', 'filters', 'options', 'student'],
};
</script>
